interface ProjectCostList {
  [key: string]: number[];
}
interface ProjectListDescription {
  [key: string]: string[];
}
interface ProjectListFTEsInclusive {
  [key: string]: boolean[];
}
// ----------------------------------------------------------------------
export const _projects_cost_list: ProjectCostList = {
  Impravata_0: [0, 0, 250000, 100000, 30000, 0, 0, 0],
  Impravata_1: [50000, 0, 150000, 120000, 50000, 0, 0, 0],
  Impravata_2: [50000, 70000, 0, 130000, 0, 200000, 0, 0],
  'Firewall Upgrade_0': [0, 0, 100000, 8000, 0, 0, 0, 0],
  'Firewall Upgrade_1': [0, 0, 115000, 8000, 0, 0, 0, 0],
  Keytronics_0: [0, 0, 30000, 53000, 0, 0, 0, 0],
  'HIM Integrations_0': [0, 0, 0, 170000, 0, 0, 0, 0],
  Handhelds_0: [0, 0, 105000, 30000, 0, 0, 5000, 0]
};
export const _projects_list_ReqFTEs: ProjectCostList = {
  project_list_0: [2, 1, 1, 3, 2]
};
export const _projects_list_FTEInclusive: ProjectListFTEsInclusive = {
  project_list_0: [true, false, true, true, false]
};
export const _projects_list_fiscalYear: ProjectCostList = {
  project_list_0: [3, 2, 1, 1, 1]
};
export const _projects_list_Budget: ProjectCostList = {
  project_list_0: [1200000, 215000, 83000, 170000, 110000]
};
export const _projects_list_FTECost: ProjectCostList = {
  project_list_0: [350000, 16000, 53000, 170000, 30000]
};
export const _projects_list_Description: ProjectListDescription = {
  project_list_0: [
    'Single sign on for the clinics',
    'Upgrading to Sophos from Jims',
    'Installing new keypads',
    'New HIM Integrations for Epic',
    'Upgrading SCM Handhelds'
  ]
};
